import { render, staticRenderFns } from "./locked_overlay.vue?vue&type=template&id=0ea4a122&scoped=true&lang=pug"
import script from "./locked_overlay.vue?vue&type=script&lang=js"
export * from "./locked_overlay.vue?vue&type=script&lang=js"
import style0 from "./locked_overlay.vue?vue&type=style&index=0&id=0ea4a122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4a122",
  null
  
)

export default component.exports